<template>
  <div class="full-height full-width row">
    <q-drawer
      v-model="state.left.show"
      :mini="!state.left.show || state.left.miniState"
      :width="220"
      :breakpoint="500"
      bordered
      content-class="bg-white column"
    >
      <q-scroll-area class="col">
        <q-list padding>
          <q-item v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label>Document OCR</q-item-label>
              <q-item-label caption style="padding-bottom:8px">
                특정 문서 도메인에 맞춰서 설계된 OCR 솔루션 입니다. <br />
                문서의 주요 내용을 key와 value로 짝을 맞춰 추출합니다.
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-separator v-show="state.left.miniState == false" />
          <q-item dense v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label caption>
                문서 OCR 내부 기능
              </q-item-label>
            </q-item-section>
          </q-item>

          <q-item v-for="(view, i) in function_list" :key="`qitem-function-${i}`"
            :active="state.page.value == view.value" clickable v-ripple @click="state.page.value = view.value"
          >
            <q-item-section avatar>
              <q-icon :name="view.icon" />
            </q-item-section>

            <q-item-section>
              {{ view.name }}
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">{{ view.name }}</q-tooltip>          
          </q-item>

          <q-separator v-show="state.left.miniState == false" />
          <q-item dense v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label caption>
                문서 OCR 테스트
              </q-item-label>
            </q-item-section>
          </q-item>
          
          <q-item v-for="(view, i) in views" :key="`qitem-${i}`"
            :active="state.page.value == view.value" clickable v-ripple @click="state.page.value = view.value"
          >
            <q-item-section avatar>
              <q-icon :name="view.icon" />
            </q-item-section>

            <q-item-section>
              {{ view.name }}
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">{{ view.name }}</q-tooltip>          
          </q-item>
        </q-list>
      </q-scroll-area>
      <q-separator />
      <q-item clickable v-ripple @click="state.left.miniState = !state.left.miniState">
        <q-item-section avatar>
          <q-icon v-if="state.left.miniState == false" name="chevron_left" />
          <q-icon v-else name="chevron_right" />
        </q-item-section>

        <q-item-section style="color:rgb(125, 125, 125);font-size:12px;">
          POWERED BY SELVAS AI
        </q-item-section>
      </q-item>
    </q-drawer>

    <q-page-container class="column col full-height full-width">
      <q-page class="column col full-height full-width" style="background:rgb(237, 238, 242);overflow:auto;">
        <template v-for="(view, i) in [...function_list, ...views]">
          <component
            v-if="state.page.value == view.value" :key="`template-${i}`" :is="view.componentName"
            :ref="view.value"
            :params="view.params"
          >
          </component>
        </template>
      </q-page>
    </q-page-container>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import BusinessRegistrationView from '@/projects/document/views/BusinessRegistrationView.vue'
import NutritionalView from '@/projects/document/views/NutritionalView.vue'
import TableView from '@/projects/document/views/TableView.vue'
import BankbookView from '@/projects/document/views/BankbookView.vue'
import FamilyRelationsView from '@/projects/document/views/FamilyRelationsView.vue'
import PrescriptionView from '@/projects/document/views/PrescriptionView.vue'
import MedicalDetailedView from '@/projects/document/views/MedicalDetailedView.vue'
import FinancialView from '@/projects/document/views/FinancialView.vue'
import DocumentClassificationView from '@/projects/document/views/DocumentClassificationView.vue'
import TrafficFineView from '@/projects/document/views/TrafficFineView.vue'
import GeneralTableView from '@/projects/document/views/GeneralTableView.vue'
import DocumentLayoutAnalysisView from '@/projects/document/views/DocumentLayoutAnalysisView'
import UltrasoundImageView from './views/UltrasoundImageView.vue'
import TestPaperView from '@/projects/document/views/TestPaperView'
import RemoveHandwritingView from '@/projects/document/views/RemoveHandwritingView.vue'
import OMRView from '@/projects/document/views/OMRView.vue'

export default {
  name: 'App',
  data: function () {
    return {
      state: {
        left: {
          show: true,
          miniState: false
        },
        page: {
          value: 'document-classification-view'
        }
      },

      function_list: [
        {
          'name': '문서 분류',
          'value': 'document-classification-view',
          'icon': 'description',
          'componentName': DocumentClassificationView
        },
        {
          'name': '표 인식',
          'value': 'table-view-method1',
          'icon': 'table_view',
          'componentName': TableView,
          'params': 1,
        },
//        {
//          'name': '표 인식 2',
//          'value': 'table-view-method2',
//          'icon': 'table_view',
//          'componentName': TableView,
//          'params': 2,
//        },
        {
          'name': '문서 구조 분석',
          'value': 'document-layout-analsis-view',
          'icon': 'description',
          'componentName': DocumentLayoutAnalysisView
        },
        {
          'name': '낙서 제거',
          'value': 'remove-handwriting-view',
          'icon': 'edit_off',
          'componentName': RemoveHandwritingView
        }
      ],
      views: [
        {
          'name': '사업자등록증',
          'value': 'business-registration-view',
          'icon': 'store',
          'componentName': BusinessRegistrationView
        },
        {
          'name': '영양기능정보',
          'value': 'nutritional-view',
          'icon': 'ramen_dining',
          'componentName': NutritionalView
        },
        {
          'name': '통장인식기',
          'value': 'bankbook-view',
          'icon': 'savings',
          'componentName': BankbookView
        },
        {
          'name': '가족관계등록부',
          'value': 'family-relations-view',
          'icon': 'family_restroom',
          'componentName': FamilyRelationsView
        },
        {
          'name': '처방전 인식',
          'value': 'prescription-view',
          'icon': 'medication',
          'componentName': PrescriptionView
        },
        {
          'name': '진료비세부내역서',
          'value': 'medical-detailed-view',
          'icon': 'medication',
          'componentName': MedicalDetailedView
        },
        {
          'name': '재무제표 인식',
          'value': 'financial-view',
          'icon': 'request_quote',
          'componentName': FinancialView
        },
        {
          'name': '과태료 통지서 인식',
          'value': 'traffic-fine-view',
          'icon': 'payments',
          'componentName': TrafficFineView
        },
        {
          'name': '범용 표문서 인식기',
          'value': 'general-table-view',
          'icon': 'table_view',
          'componentName': GeneralTableView
        },
        {
          'name': '초음파 영상',
          'value': 'ultrasound-image-view',
          'icon': 'medical_services',
          'componentName': UltrasoundImageView
        },
        {
          'name': '문제지/시험지 인식',
          'value': 'test-paper-view',
          'icon': 'history_edu',
          'componentName': TestPaperView
        },
        {
          'name': 'OMR 인식',
          'value': 'omr-view',
          'icon': 'ballot',
          'componentName': OMRView
        }
      ]
    }
  },
  components: {
    DocumentClassificationView,
    BusinessRegistrationView,
    NutritionalView,
    TableView,
    BankbookView,
    FamilyRelationsView,
    PrescriptionView,
    MedicalDetailedView,
    FinancialView,
    TrafficFineView,
    GeneralTableView,
    DocumentLayoutAnalysisView,
    UltrasoundImageView,
    TestPaperView,
    RemoveHandwritingView
  },
  methods: {
  },
  mounted () {

  }
}
</script>

<style>
#app {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  overflow: auto;
  background: rgb(239, 239, 239);
}

.body {
  display:flex;
  flex-direction:column;
  height:100%;
  width:100%;
  background: rgb(237, 238, 241);
}

.q-item-child {
  display: flex;
  flex-direction: row;
  width:100%;
}

.q-item-parent {
  display: flex;
  flex-direction: column;
  width:100%;
}

.q-toggle__thumb {
  color: red !important;
}

.q-toggle__thumb:after {
  background: rgb(230, 230, 230) !important;
}

.q-toggle__inner--indet .q-toggle__thumb:after {
  background: rgb(3, 169, 244) !important;
}

.q-toggle__inner--truthy .q-toggle__thumb:after {
  background: #027BE3 !important;
}

.q-toggle__inner.q-toggle__inner--indet {
  color:rgb(41, 182, 246);
}

::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar
{
  width: 6px;
  height: 6px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb
{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #555;
}

</style>
